<footer class="site-footer">
  <div class="footer-shell">
    <div class="footer-brand">
      <a routerLink="/" fragment="top" aria-label="D&D Twogether főoldal">
        <img src="assets/logo.svg" alt="D&D Twogether - Flowers and More" />
      </a>
      <p>{{ 'footer.address' | translate }}</p>
      <p>
        <a href="mailto:twogetherflower@gmail.com">{{ 'footer.email' | translate }}</a>
      </p>
      <p>
        <a href="tel:+36300121051">{{ 'footer.phone' | translate }}</a>
      </p>
    </div>

    <nav class="footer-nav" aria-label="Lábléc navigáció">
      <a routerLink="/szolgaltatasok">{{ 'NAV.SERVICES' | translate }}</a>
      <a routerLink="/rolunk">{{ 'NAV.ABOUT' | translate }}</a>
      <a routerLink="/kapcsolat">{{ 'NAV.VISIT_US' | translate }}</a>
      <a routerLink="/cookie-policy">{{ 'COOKIE_POLICY.TITLE' | translate }}</a>
    </nav>

    <div class="footer-social">
      <h3>{{ 'footer.follow-us' | translate }}</h3>
      <div class="social-media">
        <a href="https://facebook.com/twogetherflowers" target="_blank" rel="noopener" aria-label="Facebook">
          <img src="assets/facebook-icon.svg" alt="" />
        </a>
        <a href="https://instagram.com/twogetherflowers" target="_blank" rel="noopener" aria-label="Instagram">
          <img src="assets/instagram-white-icon.svg" alt="" />
        </a>
        <a href="https://www.tiktok.com/@twogetherflower" target="_blank" rel="noopener" aria-label="TikTok">
          <img src="assets/tiktok-icon.svg" alt="" />
        </a>
      </div>
      <a
        class="footer-order"
        href="https://shop.twogetherflower.hu"
        target="_blank"
        rel="noopener"
      >
        {{ 'footer.order' | translate }}
      </a>
      <a
        class="footer-order secondary"
        href="https://wolt.com/hu/hun/budapest/venue/dd-twogether-flowers-and-more"
        target="_blank"
        rel="noopener"
      >
        {{ 'footer.woltOrder' | translate }}
      </a>
    </div>
  </div>
</footer>
